import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Cards from "./_components/Cards";
import TableComponent from "./_components/Table";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { orgActions } from "../../Store/modules/orgModule/orgSlice";
import { GetOgranizationByID } from "./api";
import { CircularProgress } from "@material-ui/core";
import InactiveAccountDashboard from './_components/accessProgram'


const Programs = () => {

  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const org = useSelector((data) => data.org.data, shallowEqual);
  const dispatch = useDispatch();

  const [pending, setPending] = useState(false);

  const handleGetOrg = async () => {
    setPending(true)
    try{
      let res = await GetOgranizationByID(user.organization);
      dispatch(orgActions.setOrg(res.data.data));
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      alert(error);
    }finally{ 
      setPending(false);
    }
  }

  useEffect(()=>{
    if(!org){
      handleGetOrg()
    }
  }, [])

  useEffect(()=>{
    console.log(org, "=======================");
    
  }, [org])

  return (
    <div className="sub-conatainer">
      <Row className="justify-content-between align-items-center">
        <h1 className="sub-heading">Career Training and Program</h1>
        <img
          src="https://cdn.pixabay.com/photo/2016/11/07/13/04/yoga-1805784_640.png"
          alt="Logo"
          className=""
          style={{ width: "120px" }}
        />
      </Row>
      {pending && <CircularProgress
        size="20px"
        style={{ color: "#3783e7" }}
      />}
      { !pending && org && org.can_post_programs == true && <>
        <Cards />
        <TableComponent />
      </>}
      { !pending && org && org.can_post_programs == false && <InactiveAccountDashboard handleGetOrg={handleGetOrg} org={org} /> }  
    </div>
  );
};

export default Programs;
